import React from "react";

const Home = () => {
  return (
    <section id="home">
      <h1>Welcome to Infobizz</h1>
      <p>
        Infobizz is a technology-driven IT services company delivering modern,
        scalable, and secure digital solutions for startups, enterprises, and
        growing businesses worldwide.
      </p>

      <p>
        We specialize in web development, mobile app development, blockchain
        solutions, and digital branding that help businesses grow faster in the
        digital era.
      </p>

      <a href="#contact" className="btn">Get Started</a>
    </section>
  );
};

export default Home;
